import { render, staticRenderFns } from "./_sets.vue?vue&type=template&id=2cf0de49"
import script from "./_sets.vue?vue&type=script&lang=js"
export * from "./_sets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports